import { SearchRepository } from '@aipb/gulliver/catalog/data-access';
import { SearchFormMode } from '@aipb/gulliver/catalog/model';

import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'cat-search-form-mode-button',
  standalone: true,
  imports: [MatButtonModule, TranslocoPipe],
  templateUrl: './search-form-mode-button.component.html',
  styleUrls: ['./search-form-mode-button.component.scss']
})
export class SearchFormModeButtonComponent {
  @Input() mode: SearchFormMode;
  @Output() modeChange = new EventEmitter<SearchFormMode>();

  private repository = inject(SearchRepository);

  onToggle() {
    const newMode = this.mode === 'simple' ? 'advanced' : 'simple';
    this.repository.setSearchFormMode(newMode);
    this.modeChange.emit(newMode);
  }
}
